/* 
  OUTPUT FORMAT: Sep 18, 1995

  SUPPORT INPUT FORMATS
    - 18/09/1995
    - 18-09-1995
    - 1995-09-18 (ISO)
    - March 18, 1995
    - 1995-09-18T10:30:00Z (with time)
    - timestamps (1711600000000)
    - Date objects
*/
export const formatDate = (input) => {
  if (!input) return ''

  let date

  // If already a Date object
  if (input instanceof Date) {
    date = input
  }
  // If it's a number (timestamp)
  else if (!isNaN(input)) {
    date = new Date(Number(input))
  }
  // If it's a string
  else if (typeof input === 'string') {
    const trimmed = input.trim()

    // Handle dd/mm/yyyy or dd-mm-yyyy manually
    const match = trimmed.match(/^(\d{1,2})[\/-](\d{1,2})[\/-](\d{4})/)

    // Date-only ISO (YYYY-MM-DD), e.g. from the date-range picker. Parse as a *local*
    // date so a timezone offset can't shift it to the previous/next day (NDS-148).
    const isoDateOnly = trimmed.match(/^(\d{4})-(\d{2})-(\d{2})$/)

    if (match) {
      const [, day, month, year] = match
      date = new Date(year, month - 1, day)
    } else if (isoDateOnly) {
      const [, year, month, day] = isoDateOnly
      date = new Date(Number(year), Number(month) - 1, Number(day))
    } else {
      // Let JS try parsing (ISO, RFC, etc.)
      date = new Date(trimmed)
    }
  }

  // Invalid date fallback
  if (!date || isNaN(date.getTime())) {
    return input
  }

  // Format output
  return new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  }).format(date)
}

/*
  OUTPUT FORMAT: D/M/YYYY (no leading zeros, e.g. 21/2/2025)

  SUPPORTS SAME INPUT FORMATS AS formatDate
*/
export const formatEventDate = (input) => {
  if (!input) return null

  let date

  if (input instanceof Date) {
    date = input
  } else if (!isNaN(input)) {
    date = new Date(Number(input))
  } else if (typeof input === 'string') {
    const trimmed = input.trim()
    const match = trimmed.match(/^(\d{1,2})[\/-](\d{1,2})[\/-](\d{4})/)
    if (match) {
      const [, day, month, year] = match
      date = new Date(year, month - 1, day)
    } else {
      date = new Date(trimmed)
    }
  }

  if (!date || isNaN(date.getTime())) return null

  return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`
}
